import '../style/card.scss';

export default function Card ({children}) {
    return (
        <div className="page-card">
            {children}
        </div>
    )
}